import { generatePath, useNavigate } from "react-router-dom";
import {
  useCopSecurityService,
  hashTokenName,
  originalUrlQueryParamName,
  redirectUrlQueryParamName,
} from "services/security";
import { CopRoutes } from "app/routes";

const useSecurityNavigation = () => {
  const navigate = useNavigate();
  const copSecurityService = useCopSecurityService();

  function navigateToUsernamePasswordLogin(email: string, redirectUri?: string, originalUri?: string) {
    let url = `${CopRoutes.copLogin}?email=${encodeURIComponent(email)}`;
    if (redirectUri) {
      url += `&${redirectUrlQueryParamName}=${redirectUri}`;
    }
    if (originalUri) {
      url += `&${originalUrlQueryParamName}=${originalUri}`;
    }
    navigate(url);
  }

  function navigateToLoginRegistration(email: string, invitationId: number, token?: string) {
    navigate(getInvitationRegistrationPath(email, invitationId, token));
  }

  function getInvitationRegistrationPath(email: string, invitationId: number, token?: string) {
    return (
      generatePath(CopRoutes.invitationRegistration, {
        invitationId: invitationId.toString(),
      }) +
      `?email=${encodeURIComponent(email)}` +
      `${hashTokenName}${token}`
    );
  }

  function navigateToIdpLogin(email: string, idpId?: string, redirectUri?: string, originalUri?: string) {
    return copSecurityService.loginViaSpecifiedIDP(idpId, redirectUri, originalUri || CopRoutes.root, email);
  }

  return {
    getInvitationRegistrationPath,
    navigateToUsernamePasswordLogin,
    navigateToLoginRegistration,
    navigateToIdpLogin,
  };
};

export default useSecurityNavigation;
